// aiRadio/index.js - AI Radio control services
// Timing and Audio managers removed - DJ speech handled by placard system in PlayerContext

import {
  AIRadioControlManager,
  CONTROL_STATES,
  USER_ACTIONS,
  ControlUtils,
  createControlManager
} from './aiControlManager';

export {
  AIRadioControlManager,
  CONTROL_STATES,
  USER_ACTIONS,
  ControlUtils,
  createControlManager
};

// Factory for AI Radio services (control only)
export function createAIRadioServices() {
  return {
    control: createControlManager()
  };
}

export default {
  createControlManager,
  createAIRadioServices
};
